<template>
  <a-layout class="components-layout">
      <a-row class="loading-content-container">
          <a-col class="hino-logo-container">
              <img src="../assets/icons/hino.svg" alt="">
              <p v-show="isLoading">裝置開通狀態確認中...</p>
          </a-col>
      </a-row>
      <a-row class="loading-footer-container">
        <a-col>
          <p>版本號 {{packageJson.version}}</p>
        </a-col>
      </a-row>
      <ModalApiResultMsg
        :visible="visible"
        title="裝置不存在"
        okText="撥打電話"
        cancelText="否"
        msgClass="msg_error_modal"
        :okCallback="callPhoneNumber"
        :cancelCallback="hideModal">
        <p>查無此裝置資訊，請聯繫客服人員</p>
      </ModalApiResultMsg>
  </a-layout>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import packageJson from "../../package.json";
  import ModalApiResultMsg from "../components/modal/ModalApiResultMsg.vue";

  export default {
    name: 'IdentidyVerificationContainer',
    components: {
      ModalApiResultMsg,
    },
    data() {
        return {
          packageJson,
          isLoading: false,
          visible: false,
        };
    },

    mounted() {
      this.verifyIdentity();
    },
    methods: {
      ...mapActions('identidyOpenStatus', ['deviceUidAction', 'openStatusAction']),
      ...mapActions('identidyInfo', ['identidyInfoAction']),
      async saveDeviceUid() {
        try {
          // this.deviceUid = this.$route.query.data || '';
          // this.deviceUidAction(this.deviceUid);
          const deviceUid = this.$route.query.data || '';
          this.deviceUidAction(deviceUid);
        } catch (error) {
          console.log(error);
        }
      },
      async verifyIdentity() {
        try {
          this.isLoading = true;
          await this.saveDeviceUid();
          const params = {
            encodedImei: this.deviceUid,
            // deviceUid: this.deviceUid,
          };
          const res = await this.openStatusAction(params);
          console.log('open status:' , res);
          const { openedUser, carNo, openedMobile } = res;

          await this.identidyInfoAction({
            name: openedUser,
            carNo: carNo,
            phone: openedMobile,
          });
          this.turnToPage(res.opened);
        } catch (error) {
          console.log('openStatus', error);
          this.isLoading = false;
          this.visible = true;
        }
      },
      turnToPage(openStatus) {
        setTimeout(()=> {
            switch (openStatus) {
                // 未開通
                case 0:
                this.$router.push(`/provisioning/step1?data=${encodeURIComponent(this.deviceUid)}`);
                break;
                // 已開通
                case 1:
                this.$router.push(`/individual/monitor?data=${encodeURIComponent(this.deviceUid)}`);
                break;
                // 已過期
                case 2:
                this.$router.push(`/individual/deviceInfo?data=${encodeURIComponent(this.deviceUid)}`);
                break;
                default:
                break;
            }
        }, 2000);
      },
      callPhoneNumber() {
        location.href='tel:02-12345678';
        this.hideModal();
      },
      hideModal() {
        this.visible = false;
      },
    },
    computed: {
      ...mapState('identidyOpenStatus', ['deviceUid']),
    },
  }
</script>

<style scoped lang="scss">
  .components-layout {
    background: #ffff;
    .loading-content-container {
      height: 80vh;
      display: flex;
      justify-content: center;
      align-items: center;
      .hino-logo-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        img {
          width: 40%;
        }
        p {
          margin-top: 5rem;
          font-size: 16px;
          line-height: 24px;
          color: #343741;
        }
      }
    }
    .loading-footer-container {
      height: 20vh;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        color: #C0E560;
      }
    }
  }
</style>
